// tslint:disable:max-line-length

import React from 'react';

export const OperatorSubtract = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M4,8.76V6.87h8V8.76Z" />
    </svg>
  );
};
